interface ExpansionTenantRow {
  tenantId: string;
  tenantName: string;
  cersBusinessId: string;
  businessName?: string | null;
  unmatchedCount: number;
}

interface ExpansionStats {
  unmatchedTotal: number;
  tenantsWithGaps: number;
  netNewTotal: number;
  netNewBusinesses: number;
}

type ExpansionTableRow =
  | {
      kind: "tenant";
      id: string;
      tenantId: string;
      tenantName: string;
      cersBusinessId: string;
      businessName: string | null;
      unmatchedCount: number;
    }
  | { kind: "net-new"; id: string; unmatchedCount: number; businessCount: number };

export function buildExpansionTableRows(
  byTenant: ExpansionTenantRow[],
  stats: ExpansionStats
): ExpansionTableRow[] {
  const rows: ExpansionTableRow[] = byTenant.map((r) => ({
    kind: "tenant",
    id: `${r.tenantId}:${r.cersBusinessId}`,
    tenantId: r.tenantId,
    tenantName: r.tenantName,
    cersBusinessId: r.cersBusinessId,
    businessName: r.businessName ?? null,
    unmatchedCount: r.unmatchedCount,
  }));
  if (stats.netNewTotal > 0) {
    rows.push({
      kind: "net-new",
      id: "net-new",
      unmatchedCount: stats.netNewTotal,
      businessCount: stats.netNewBusinesses,
    });
  }
  return rows;
}
